import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayJoin',
  standalone: true,
})
export class ArrayJoinPipe implements PipeTransform {
  transform(item: any[], attr: string[]): any {
    if (attr.length === 2) {
      return item
        .map((i) => i[attr[1]])
        .filter((v) => v !== '')
        .join(attr[0]);
    } else {
      return item.filter((v) => v !== '').join(attr[0]);
    }
  }
}
